import { createContext, useContext } from 'react';
import noop from 'utils/noop';

type EditState = {
  isEditingMedium: boolean;
  setIsEditingMedium: (isEditing: boolean) => void;
  isEditingMessageType: (id: number) => boolean;
  createSetIsEditingMessageType: (id: number) => (isEditing: boolean) => void;
  clearEditState: () => void;
};

export const defaultState = {
  isEditingMedium: false,
  setIsEditingMedium: noop,
  isEditingMessageType: () => false,
  createSetIsEditingMessageType: () => noop,
  clearEditState: noop,
};

export const EditStateContext = createContext<EditState>(defaultState);

export const useEditStateContext = () => useContext(EditStateContext);
